import React, { FC, PropsWithChildren, useEffect } from 'react'

import { styled } from '@linaria/react'

import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'

import { blockPadding, desktopWidth } from './WaveBoarding.constants'

const Block = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${blockPadding};
  box-sizing: border-box;
  background-size: cover;

  @media (min-width: ${breakpoints.mobile}px) {
    /* stylelint-disable-next-line declaration-property-value-disallowed-list */
    width: var(--width, 100%);
    /* stylelint-disable-next-line declaration-property-value-disallowed-list */
    opacity: var(--opacity, 0);
    transition: 0.5s ease-in-out;
    transition-property: opacity, width;
  }

  @media (max-width: ${breakpoints.mobile - 1}px) {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`

const ReversedBlock = styled(Block)`
  @media (max-width: ${breakpoints.mobile - 1}px) {
    flex-direction: column-reverse;
  }
`

/**
 * Анимированный блок, появляющийся при прокрутке
 */
export const AnimatedBlock: FC<
  { type?: 'normal' | 'reversed' } & PropsWithChildren
> = ({ type = 'normal', children }) => {
  const { setNode, entry } = useIntersectionObserver({
    threshold: 0.5,
  })

  useEffect(() => {
    if (entry?.isIntersecting) {
      const block = entry.target as HTMLDivElement

      if (document.documentElement.clientWidth > breakpoints.mobile) {
        block.style.setProperty('--width', desktopWidth)
        block.style.setProperty('--opacity', '1')
      }
    }
  }, [entry?.isIntersecting, entry?.target])

  switch (type) {
    case 'normal':
      return <Block ref={setNode}>{children}</Block>
    case 'reversed':
      return <ReversedBlock ref={setNode}>{children}</ReversedBlock>
  }
}
